/**
 * O site público, que mora em outro domínio.
 *
 * É o espelho do `destinos.ts` do lado de lá: a landing entrega o visitante no
 * app, e o app devolve o aluno ao site quando o conteúdo é público. Hoje isso
 * acontece num lugar só - as Notícias Recentes da tela de início.
 *
 * **A notícia não ganhou tela no app, e é decisão, não pendência.** Ela é o
 * único conteúdo nosso que abre sem conta (PR-35), e a página que a mostra já
 * existe, indexável, com prévia de link e capa remontada. Uma segunda cópia
 * dentro do app seria o mesmo HTML renderizado duas vezes, e a que divergiria
 * primeiro é justamente a que ninguém abre para conferir.
 */
const SITE = import.meta.env.VITE_SITE_URL ?? 'https://titularis.com.br';

/** Uma notícia, pelo endereço que ela tem no site. */
export const enderecoDaNoticia = (slug: string): string =>
  `${SITE}/noticias/${encodeURIComponent(slug)}`;

/** A listagem inteira, para quem quer ver mais do que as três da tela. */
export const enderecoDasNoticias = `${SITE}/noticias`;

/**
 * Provas para Imprimir, que mora no site pelo mesmo motivo das notícias.
 *
 * Ela abre sem conta - é o canal por onde a prova em PDF chega a quem pediu -,
 * e o `apps/app` inteiro vive atrás do `RequireAuth`. Uma cópia da tela aqui
 * dentro seria o mesmo leitor mantido em dois lugares.
 *
 * **O aluno logado não perde nada indo para lá:** o cookie é de
 * `.titularis.com.br`, então ele chega identificado e o download, que exige
 * conta, funciona sem passar por login de novo.
 */
export const enderecoDasProvas = `${SITE}/provas`;

/**
 * Os dois documentos legais, que também moram no site.
 *
 * **Eles abrem sem conta de propósito**, e é isso que os põe do lado de lá: o
 * art. 9º da LGPD quer o tratamento declarado de forma acessível, e o Decreto
 * 7.962/2013 quer as condições do contrato disponíveis **antes** da compra.
 * Atrás do `RequireAuth`, os dois falhariam para quem mais precisa deles - quem
 * ainda está decidindo se cria a conta.
 */
export const enderecoDosTermos = `${SITE}/termos`;
export const enderecoDaPrivacidade = `${SITE}/privacidade`;
